import React from "react";
import PuzzlePromotionPanel from "../../pzl_common/stats/PuzzlePromotionPanel";
import StatsJigsawService from "../../../services/StatsJigsawService";

const EMAIL_TYPES = [
    { value: "jigsaw_muse_review", label: "Jigsaw Muse review request" },
];

export default function JigsawPromotionPanel({ language }) {
    return (
        <PuzzlePromotionPanel
            language={language}
            storageKeyPrefix="admin.jigsaw.promotion"
            fetchUsers={StatsJigsawService.promotionUsers}
            defaultAppId="jigsaw_muse"
            defaultAppName="Jigsaw Muse"
            emailTypes={EMAIL_TYPES}
            emptyLabel="No Jigsaw Muse players."
            description="Signed-in Jigsaw Muse players with play records. Name / Email shows the display name and address separately. Email share: Shared is a personal address, Apple relay is Sign in with Apple Hide My Email (@privaterelay.appleid.com — you can still see that relay address). Sorted by last play (newest first). Select players to send a promotion email. Click a name to open the account."
            dialogHint="Compose and send from Advertisement → Promotion. Create new, then select Jigsaw Muse to load the template. Recipient history is in system_log (source PromotionEmail)."
        />
    );
}
